import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import NonStaffedContractor from 'src/models/personnel/NonStaffedContractor';

interface INsContractorsDialogProps {
    dialogName: string;
    items: Array<NonStaffedContractor>;
    onClose: () => void;
}

// Mirrors manager_commission.fmt's "NS_Contractors" window (block Non_Staffed_Contractors) - a
// flat, scrollable list of managers/projects/contractors that must be staffed before Build
// Manager Review/Rebuild/Add Period can proceed for a period (see CommissionService's
// IsNonStaffedContractor guard, ported from PM_COMM.fn_NonStaffedContractors). Same OK-only, no
// Cancel pattern as the real window (Access_Non_Staffed_Contractors just queries the block -
// there's nothing to confirm or reject here, only to go fix and try again).
const NsContractorsDialog = (props: INsContractorsDialogProps) => {
    return (
        <Dialog title="Contractors must be staffed to calculate Production Bonus." dialogName={props.dialogName} bodyStyle={{ width: '55%' }} isExitButtonInvisible={true}>
            <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                <thead>
                    <tr>
                        <th className="table-header" style={{ width: '30%' }}>Manager</th>
                        <th className="table-header" style={{ width: '15%' }}>Period No.</th>
                        <th className="table-header" style={{ width: '20%' }}>Project</th>
                        <th className="table-header" style={{ width: '35%' }}>Contractor</th>
                    </tr>
                </thead>
            </table>
            <div style={{ maxHeight: '40vh', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                    <tbody>
                        {props.items.length === 0 && (
                            <tr>
                                <td colSpan={4} style={{ textAlign: 'center', padding: '1rem' }}>No non-staffed contractors for this period.</td>
                            </tr>
                        )}
                        {props.items.map((item, index) => (
                            <tr key={`${item.tsdMgr}-${item.clNo}-${item.prNo}-${item.tsdNo}-${index}`}>
                                <td style={{ width: '30%' }}>{item.tsdMgr} - {item.mgrName}</td>
                                <td style={{ width: '15%' }}>{item.periodNo}</td>
                                <td style={{ width: '20%' }}>{item.clNo}-{item.prNo}</td>
                                <td style={{ width: '35%' }}>{item.tsdNo} - {item.personName}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="button-row" style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                <Button className="blue-hover-button" style={{ width: '10rem' }} text="OK" onClick={() => props.onClose()} />
            </div>
        </Dialog>
    );
};

export default NsContractorsDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/NsContractorsDialog.tsx